import { render, staticRenderFns } from "./TaskListV2.vue?vue&type=template&id=59fbe438&scoped=true&lang=pug"
import script from "./TaskListV2.vue?vue&type=script&lang=js"
export * from "./TaskListV2.vue?vue&type=script&lang=js"
import style0 from "./TaskListV2.vue?vue&type=style&index=0&id=59fbe438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbe438",
  null
  
)

export default component.exports